import {LabelSmall} from '@travel-frontend/ui-components';

type Props = React.PropsWithChildren<{
  highlighted?: boolean;
}>;

/**
 * @FIXME update toolkit component instead
 */
export const SliderLabel: React.FunctionComponent<Props> = ({
  highlighted,
  children,
}) => {
  return (
    <LabelSmall
      fontWeight={highlighted ? 'bold' : undefined}
      color={highlighted ? 'interactionSecondary' : undefined}
    >
      {children}
    </LabelSmall>
  );
};
